import { changeOrganizationMembersRoleAndStatusBulkActionType, } from '../../../../../../backend/features/organizations/shared';
import { useContactManagementTranslation } from '../../../../../../ui/hooks/useContactManagementTranslation';
import { getFilterForBulkAction } from '../../../../../../utils';
import { handleErrorDialog, showConfirmDialog, showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { OrganizationRoleOrStatusRadioGroup } from './OrganizationRoleOrStatusRadioGroup';
export function showChangeOrganizationMemberStatusDialog(params) {
    showCustomDialog({
        fullWidth: true,
        maxWidth: 'sm',
        content: (close) => React.createElement(OrganizationMemberStatusDialog, Object.assign({}, params, { close: close })),
    });
}
const OrganizationMemberStatusDialog = (props) => {
    const settings = useSelector(getSettings);
    const { orgStatusMap, orgRoleMap } = settings;
    const { t } = useContactManagementTranslation();
    const [selectedStatus, setSelectedStatus] = React.useState();
    const selectedCount = props.selectedAccountIds.length > 0 ? props.selectedAccountIds.length : props.filteredRowCount;
    const handleChange = (event) => {
        setSelectedStatus(event.target.value);
    };
    const handleChangeStatus = (statusRequiresRole) => {
        const newRole = statusRequiresRole ? props.defaultRole : undefined;
        try {
            launchBulkAction({
                type: changeOrganizationMembersRoleAndStatusBulkActionType,
                title: t('forms.orgMembers.applyingBulkChanges'),
                params: {
                    organizationId: props.organizationId,
                    newRole,
                    newStatus: selectedStatus,
                    filter: getFilterForBulkAction(props.selectedAccountIds, props.appliedStorageFilters),
                },
                onClose: () => {
                    props.onAfterSave();
                    props.close();
                },
            });
        }
        catch (error) {
            handleErrorDialog(error);
        }
    };
    const handleSave = () => {
        var _a, _b;
        if (selectedStatus) {
            const statusRequiresRole = selectedStatus ? !!((_a = orgStatusMap[selectedStatus]) === null || _a === void 0 ? void 0 : _a.requireOrgRole) : false;
            const statusLabel = selectedStatus ? (_b = orgStatusMap[selectedStatus]) === null || _b === void 0 ? void 0 : _b.label : '';
            let note = '';
            if (statusRequiresRole && props.defaultRole) {
                note = t('forms.orgMembers.changeStatusNoteWillSetDefaultRole', {
                    status: statusLabel,
                    role: orgRoleMap[props.defaultRole].label,
                });
            }
            else if (!statusRequiresRole && selectedStatus) {
                note = t('forms.orgMembers.changeStatusNoteRoleWillBeRemoved', { status: orgStatusMap[selectedStatus].label });
            }
            showConfirmDialog({
                title: t('forms.orgMembers.changeAccountStatus'),
                content: (React.createElement(React.Fragment, null,
                    React.createElement(Typography, null, t('forms.orgMembers.changeStatusQuestion', { count: selectedCount })),
                    React.createElement(Typography, null, note),
                    React.createElement(Typography, null, t('panels.accounts.changeStatus.currentUserNotChanged')))),
                onConfirm: () => handleChangeStatus(statusRequiresRole),
            });
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogTitle, null, t('panels.accounts.changeStatus.dialogTitle', { count: selectedCount })),
        React.createElement(DialogContent, null,
            React.createElement(OrganizationRoleOrStatusRadioGroup, { items: orgStatusMap, selected: selectedStatus, handleChange: handleChange, dataTestPrefix: 'status' })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { color: 'primary', onClick: () => props.close(), "data-test": 'cancel-button' }, t('common.cancel')),
            React.createElement(Button, { color: 'primary', disabled: !selectedStatus, onClick: handleSave, "data-test": 'save-button' }, t('common.save')))));
};
